import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetBlogListAppendSucceed, EGetBlogListActionType } from './types';
import { IBlogList } from '../../../types/blogList';

export const getBlogListAppendSucceed: (data: IBlogList) => TGetBlogListAppendSucceed = actionGenerator<
  EGetBlogListActionType.AppendSucceed,
  IBlogList
>(EGetBlogListActionType.AppendSucceed);
